import { faArrowLeft } from "@fortawesome/pro-solid-svg-icons";
import { parse } from "query-string";
import React from "react";

import BlogPost from "@/mk2/apps/blogs/components/BlogPost/BlogPost";
import { AUTH_KEY_NAME } from "@/mk2/apps/blogs/constants";
import { blogsUrl } from "@/mk2/apps/blogs/urls";
import { Btn, BtnType } from "@/mk2/components/Btn";
import { Failure } from "@/mk2/components/errors/Failure";
import Complaint from "@/mk2/containers/Complaint/Complaint";
import { ComplaintTargetType } from "@/mk2/containers/Complaint/Complaint.schemas";
import { LoadingSwitch } from "@/mk2/containers/LoadingSwitch/LoadingSwitch";
import { BACK_TO_BLOGS } from "@/mk/autogenerated/translation";

import styles from "./BlogsShortMessageDetail.mscss";
import { Props } from "./BlogsShortMessageDetailPage";

export class BlogsShortMessageDetail extends React.PureComponent<Props> {
    public render() {
        const { loadingState, post } = this.props;

        return (
            <div className={styles.BlogsShortMessageDetail}>
                <LoadingSwitch
                    loadingState={loadingState}
                    onLoad={this.load}
                    onRenderSuccess={this.renderSuccess}
                    onRenderFailure={this.renderFailure}
                    hasData={!!post}
                />
            </div>
        );
    }

    private renderFailure = () => {
        const { errorMessage } = this.props;

        return (
            <Failure
                errorMessage={errorMessage}
                onRetry={this.load}
                backButton={
                    <Btn
                        type={BtnType.Blue}
                        label={BACK_TO_BLOGS}
                        icon={faArrowLeft}
                        link={blogsUrl}
                    />
                }
            />
        );
    };

    private renderSuccess = () => {
        const {
            post,
            requestUser,
            requestUserPermissions,
            location,
            history,
            commentsCount,
            complaintsCount,
            isMobile,
            onIgnoreUser,
            onPostToggleMenuMore,
            onPostToggleVisibilityMenuMore,
            onSetDisplayingAtFeed,
            onReport,
            onSetVisibility,
        } = this.props;

        return (
            <React.Fragment>
                <Complaint
                    id={post.id}
                    entity={ComplaintTargetType.PhotoblogPost}
                    className={styles.BlogsShortMessageDetail__complaint}
                    scrollOffset={44 + 44 + 30 /* header + 30px spacing */}
                    inForum={false}
                    inGroups={post && "group" in post && !!post.group}
                />

                <BlogPost
                    post={post}
                    forceEagerImages
                    isMobile={isMobile}
                    commentsCount={commentsCount}
                    complaintsCount={complaintsCount}
                    requestUser={requestUser}
                    requestUserPermissions={requestUserPermissions}
                    onDelete={this.handleDelete}
                    onIgnoreUser={onIgnoreUser}
                    onReport={onReport}
                    onSetDisplayingAtFeed={onSetDisplayingAtFeed}
                    onSetVisibility={onSetVisibility}
                    onToggleMenuMore={onPostToggleMenuMore}
                    onToggleVisibilityMenuMore={onPostToggleVisibilityMenuMore}
                    isPreloaded
                    location={location}
                    history={history}
                />
            </React.Fragment>
        );
    };

    private handleDelete = (postId) => {
        this.props.onDelete(postId);
    };

    private load = () => {
        const {
            match: {
                params: { username, postSlug },
            },
            onLoad,
            location,
        } = this.props;
        const q = parse(location.search);

        onLoad(username, postSlug, q[AUTH_KEY_NAME] as string);
    };
}
